import React from "react";

import { CronJobType } from "../../../../../../../../../util/enums";
import { useActionReportMaintenance } from "../../../hooks/useAction";
import { useReportState } from "../../../hooks/useReportState";
import { BaseReportGrid } from "../../BaseReportGrid";
import { useProductColumns } from "./hooks/useProductsColumns";
import { useProductsFilters } from "./hooks/useProductsFilters";

export const ProductsReport = () => {
  const { getAllProducts } = useActionReportMaintenance();
  const { type, ...reportStateProps } = useReportState();
  const {
    getProductReportFilters,
    getProductReportRequiredFilters,
    getProductReportPeriodOptions,
    getProductReportDateOptions,
  } = useProductsFilters();
  const { getProductReportColumns } = useProductColumns();

  return (
    <BaseReportGrid
      getAllData={getAllProducts}
      columns={getProductReportColumns(type)}
      filterCategories={getProductReportFilters(type)}
      filterByOptions={type === CronJobType.STOCK ? undefined : getProductReportFilters(type)}
      dateOptions={getProductReportDateOptions(type)}
      periodOptions={getProductReportPeriodOptions(type)}
      minFilters={type === CronJobType.STOCK ? 1 : undefined}
      requiredFilters={getProductReportRequiredFilters(type)}
      {...reportStateProps}
    />
  );
};
